import React, { useEffect, useRef, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Navbar from '../Navbar/Navbar'
import { fetchCategories } from '../../features/Books/BooksAction'
import {Link, useNavigate } from 'react-router-dom'
import { statesAndCities } from '../../Common/Api/locationData'
import { states } from '../../Common/Api/locationData'
import "./Homepage.css"

export default function Homepage() {
    const dispatch = useDispatch();
    const { books ,categories  } = useSelector((state)=>{
        return (state.Books);
    })

    const [arrayBooks, setArrayBooks] = useState(new Set())
    const [States, setStates] = useState(new Set())
    const [Cities, setCities] = useState(new Set())

    const [titleValue, setTitleValue] = useState("");
    const [StateValue, setStateValue] = useState("");
    const [CityValue, setCityValue] = useState("");
    
    const keypress = useRef()
    useEffect(() => {
        dispatch(fetchCategories(1));

        setStates(states);
        books.map((book) => {
            // console.log(book.title," book")
            setArrayBooks((prevSet) => {
                const newSet = new Set(prevSet);
                newSet.add(book.title);
                return newSet;  
            })
            // console.log(arrayBooks," array")
        })


    }, [])

    const handleSuggestion = (e) => {
        e.preventDefault();
        console.log(arrayBooks)
        setTitleValue(e.target.value)
        onChange(e);
    }
    const handleState = (e) => {
        e.preventDefault();
        console.log(states)
        setStateValue(e.target.value)
        setCities(new Set(statesAndCities[e.target.value]))
        onChange(e);
    }
    const handleCity = (e) => {
        e.preventDefault();
        console.log(Cities)
        setCityValue(e.target.value)
        onChange(e);
    }
      const navigate = useNavigate();
      const [searchInput,setSearchInput] = useState({title:'',category:'',state:'',city:''});

      const onChange = (e)=>{
        e.preventDefault();
        console.log(e.target.name , e.target.value)
        setSearchInput({...searchInput,[e.target.name]:e.target.value});

      }

      const handleSearch = async(e)=>{
            e.preventDefault();
            console.log(searchInput);

            navigate(`/search-result/:${searchInput.category}/:/:${titleValue}/:${CityValue}`);
    }
      useEffect(() => {
    const keyDownHandler = event => {
      console.log('User pressed: ', event.key);

      if (event.key === 'Enter') {
        event.preventDefault();
        keypress.current.click();
    //    handleSearch(event)
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  });



  return (
      <div className="Homepage">
          <Navbar colorRight = "#5f2c3e" colorLeft = "#fae5df" />

          <div className="homepage-container">

              <div className='home-left'>
                
                <h1>
                    {books.length} Used Books
                </h1>
                <h1>
                    On Sale
                </h1>

                <p>Buy And Sell Used Books In India. Search And Buy Second Hand Books Near You. Post Free Ad To Sell Old Books In City. Download the app now.</p>

                <Link to='/postAd'><button>Sell Used Books</button></Link>

              </div>


              <div className='home-right'>
                
                <form className='home-form' onSubmit={handleSearch}>

                    <div className='form-comp'>
                        <label className='home-form-label'>Title</label>
                        <div>
                              <input required = {true} className='home-form-input' placeholder='What are you looking for?' onChange={handleSuggestion} value={titleValue} />
                              <ul className='suggestion-list' >
                                  {
                                     Array.from(arrayBooks).filter((book) => {
                                            return titleValue && titleValue.toLowerCase !== book.toLowerCase() && book.toLowerCase().includes(titleValue.toLowerCase())
                                      }).slice(0,6).map((book) => {
                                            console.log(book)
                                          return <li className='suggestion-list-item' onClick={()=>setTitleValue(book)} >{book}</li>
                                        })    
                                  }
                              </ul>
                        </div>
                    </div>
                    <div className='form-comp'>
                        <label className='home-form-label'>Select Category</label>
                        <div>
                              <select required={true} className='home-form-input' placeholder='Select Category' name='category' value={searchInput.category} onChange={onChange}>
                                  {
                                      categories.map((category) => {
                                            return <option value={category._id} key={category._id}>{category.name}</option>
                                        })
                                  }
                            </select>
                        </div>
                    </div>
                    <div className='form-comp'>
                        <label className='home-form-label'>State</label>
                        <div>
                            <input required = {true} className='home-form-input' placeholder='Enter State' name='state' value={StateValue} onChange={handleState} />
                                  {
                                     Array.from(States).filter((state) => {
                                            return StateValue && StateValue.toLowerCase !== state.toLowerCase() && state.toLowerCase().includes(StateValue.toLowerCase())
                                      }).slice(0,6).map((state) => {
                                          return <li className='suggestion-list-item' onClick={() => {
                                            //   console.log(state)
                                              setStateValue(state)
                                              setCities(new Set(statesAndCities[state]))
                                          }} >{state}</li>
                                        })  
                                }
                        </div>
                    </div>
                    <div className='form-comp'>
                        <label className='home-form-label'>Cities</label>
                        <div>
                            <input className='home-form-input' placeholder='Enter City' name='City' value={CityValue} onChange={handleCity}/>
                              {
                                  Array.from(Cities).filter((city) => {
                                        return CityValue && CityValue.toLowerCase !== city.toLowerCase() && city.toLowerCase().includes(CityValue.toLowerCase())
                                  }).slice(0, 6).map((city) => {
                                      return <li className='suggestion-list-item' onClick={() => {
                                          console.log(city)
                                          setCityValue(city)
                                      }} >{city}</li>
                                    })
                                }
                           
                        </div>
                    </div> 
                    <button ref={keypress} type="submit" className="home-btn">Submit</button>
                </form>
                
              </div>
          </div>
    </div>
  )
}
